import { getFactoryTestId } from '@utils';

export const TestId = (componentName: string) => {
	const getTestId = getFactoryTestId(componentName);

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	return (target: any) => {
		target.prototype.getTestId = (testId: string) => getTestId(testId);

		return target;
	};
};